import React, { useState } from 'react';
import { GiLockedHeart } from "react-icons/gi"; 
import { BiEnvelope } from "react-icons/bi"; 
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import './Login.css';
import Phone from './phone.svg';
import Logo from './Logo.svg';
import { users } from '../Data/userLogin';


function Login() {

    const [email, setEmail] = useState('admin@yopmail.com');
    const [password, setPassword] = useState('admin123');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const user = users.find(u => u.email === email && u.password === password);
    
        if (user) {
            // Stockez les informations de l'utilisateur dans le localStorage
            localStorage.setItem('user', JSON.stringify(user)); // Convertir l'objet en chaîne JSON
            toast.success('Connexion réussie !');
            setTimeout(() => {
                navigate('/main-layout');
            }, 2000);
        } else {
            toast.error('Connexion échouée : Email ou mot de passe incorrect.');
        }
    };

  return (
    <div className="login-global-container"> {/* Ajoutez ce conteneur global */}
            <div className="login-container">
                <ToastContainer />
                <div className="left-section">
                    <img src={Logo} alt="Logo CNAR" className="logo" />
                    <h1>Gestion des Cartes Djiguiya Santé</h1>
                    <img src={Phone} alt="Mobile Illustration" className="illustration" />
                </div>
                <hr className="separator"></hr>
                <div className="right-section">
                    <p>Connectez-vous !</p>
                    <h2>Connexion</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <div className="input-container">
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Entrez votre email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <BiEnvelope className="input-icon" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Mot de passe</label>
                            <div className="input-container">
                                <input
                                    type="password"
                                    id="password"
                                    placeholder="Entrez votre mot de passe"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <GiLockedHeart className="input-icon" />
                            </div>
                        </div>
                        <button type="submit" className="btn">Connexion</button>
                        <p className="signup-text">Pas de compte ? <a href="/login">Inscrivez-vous</a></p>
                    </form>
                </div>
            </div>
        </div>
  )
}

export default Login